import React, { useState, useCallback } from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import StepAttachmentsDialog from './StepAttachmentsDialog';

export interface StepAttachmentsButtonProps {
  projectId: string;
  stepId: string;
  stepLabel?: string;
  /** 업로드/삭제 노출 여부. view 모드에서도 다운로드는 가능. */
  editable: boolean;
  /** 표시할 첨부 수. undefined 면 배지 숨김. */
  count?: number;
  /** 다이얼로그 닫힐 때 호출 (개수 갱신용). */
  onChanged?: () => void;
  /** 버튼 크기. */
  size?: 'small' | 'medium';
}

const StepAttachmentsButton: React.FC<StepAttachmentsButtonProps> = ({
  projectId,
  stepId,
  stepLabel,
  editable,
  count,
  onChanged,
  size = 'small',
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  }, []);
  const handleClose = useCallback(() => setOpen(false), []);

  const tooltip = count && count > 0 ? `첨부 ${count}개` : '첨부 파일';

  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton
          size={size}
          onClick={handleOpen}
          sx={{ color: 'text.secondary' }}
          aria-label={tooltip}
        >
          <Badge badgeContent={count ?? 0} color="primary" overlap="circular" max={99}>
            <AttachFileIcon fontSize={size === 'small' ? 'small' : 'medium'} />
          </Badge>
        </IconButton>
      </Tooltip>
      {open && (
        <StepAttachmentsDialog
          open={open}
          onClose={handleClose}
          projectId={projectId}
          stepId={stepId}
          stepLabel={stepLabel}
          editable={editable}
          onChanged={onChanged}
        />
      )}
    </>
  );
};

export default StepAttachmentsButton;
